import _ from 'lodash';
import { getMaxZIndex } from 'crazyEditor/core/elements/utils/elementFilterUtils';
import * as elementActionTypes from '../actions/mobileElementActions';
import update from 'react-addons-update';
import { PAGE_ELEMENT_ID, BACKGROUND_ELEMENT_ID, getPageElement } from 'crazyEditor/core/elements/utils/elementStaticUtils';
import { SPACE_BETWEEN_MOBILE_ELEMENTS, CONTAINING_MOBILE_ELEMENT_BOUNDRIES, MOBILE_CONTENT_WIDTH, ADD_MOBILE_ELEMENTS_FIRST_STEP, ADD_MOBILE_ELEMENTS_SECOND_STEP, ADD_MOBILE_ELEMENTS_THIRD_STEP, MINIMUM_MOBILE_FONT_SIZE } from 'crazyEditor/core/constants/editorConstants';
import { getMobileDOMNodeById } from 'crazyEditor/core/elements/utils/elementRefUtils';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import { getElementList } from '../helpers/elementListHelpers';
import { isTextElement, isFullWidth, shouldPreserveAspectRatio } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { getElementFontSize } from 'crazyEditor/core/elements/utils/commonElementMethods';
import { getContainingElementsTree, getAllContainedElements, getAllContainingElements, getElementRect, getUpdatedMobileElementsAfterDelete } from '../helpers/mobileElementHelpers';
import { getHiddenElements, getVisibleElements } from 'crazyEditor/core/elements/utils/elementFilterUtils';
import { getYPositionAtMiddleOfView } from '../helpers/elementPositionHelpers';

function resizeMobileElements(elements, pageElement) {
  let lowestElement = 0;
  const elementsToUpdate = {
    elements: {},
    staticElements: {}
  };
  _.forEach(elements, (element) => {
    if (element.hidden || element.parentId) {
      return;
    }
    const DOMElement = getMobileDOMNodeById(element.id) || document.getElementById(element.id);
    let height = DOMElement.offsetHeight;
    if (!height) {
      height = element.layout.height;
    }
    if (height !== element.layout.height) {
      elementsToUpdate.elements[element.id] = {
        layout: {
          height: {
            $set: height
          }
        }
      };
    }
    lowestElement = lowestElement ? Math.max(lowestElement, element.layout.y + height) : element.layout.y + height;
  });

  if (pageElement && (!pageElement.layout.height || lowestElement > pageElement.layout.height)) {
    elementsToUpdate.staticElements[PAGE_ELEMENT_ID] = {
      layout: {
        height: {
          $set: lowestElement
        }
      }
    };
  } else {
    delete elementsToUpdate.staticElements;
  }

  return elementsToUpdate;
}

function getChildElements(elements) {
  const childElements = {};
  _.forEach(_.filter(elements, 'parentId'), (childElement) => {
    childElements[childElement.id] = childElement;
  });
  return childElements;
}

function getCombinedLayout(overlappingElements) {
  const elementsRects = _.map(overlappingElements, (element) => getElementRect(element));
  const top = _.min(_.map(elementsRects, (rect) => rect.top));
  const left = _.min(_.map(elementsRects, (rect) => rect.left));
  return {
    height: _.max(_.map(elementsRects, (rect) => rect.bottom)) - top,
    width: _.max(_.map(elementsRects, (rect) => rect.right)) - left,
    x: left,
    y: top,
  };
}

function getUpdatedMobileLayout(layout, currYPosition, containerLayout, isElementFullWidth) {
  let resizedLayout;
  const containerWidth = containerLayout.width - (2 * CONTAINING_MOBILE_ELEMENT_BOUNDRIES);
  if (isElementFullWidth) {
    resizedLayout = _.assign({}, layout, {
      x: 0,
      y: currYPosition
    });
  } else if (layout.width > containerWidth) {
    let ratio = layout.aspectRatio;
    if (!ratio) {
      ratio = layout.width / layout.height;
    }
    resizedLayout = _.assign({}, layout, {
      width: containerWidth,
      height: Math.ceil(containerWidth / ratio),
      x: isElementFullWidth ? 0 : containerLayout.x + CONTAINING_MOBILE_ELEMENT_BOUNDRIES,
      y: currYPosition
    });
  } else {
    resizedLayout = _.assign({}, layout, {
      x: containerLayout.x + Math.ceil((containerLayout.width - layout.width) / 2),
      y: currYPosition
    });
  }
  return resizedLayout;
}

function checkIfElementsOverlap(firstElementRect, secondElementRect) {
  return !(
    firstElementRect.left > secondElementRect.right ||
    firstElementRect.right < secondElementRect.left ||
    firstElementRect.top > secondElementRect.bottom ||
    firstElementRect.bottom < secondElementRect.top
  );
}

function checkIfTextThatCanOverlap(firstElement, secondElement) {
  return (((isTextElement(firstElement.type)) &&
  (secondElement.type === elementTypes.ImageElement || secondElement.type === elementTypes.IconElement || secondElement.type === elementTypes.ShapeElement)) ||
  ((firstElement.type === elementTypes.ImageElement || firstElement.type === elementTypes.IconElement || firstElement.type === elementTypes.ShapeElement) &&
  (isTextElement(secondElement.type))));
}

function findOverlappingElements(newDesktopElements, desktopIdsNewMobileElements, currDesktopElement, allContainingElements) {
  const currElementRect = getElementRect(currDesktopElement);
  const directlyOverlappingElements = [];
  const nonOverlappingElements = [];
  let overlappingElements = [];
  _.forEach(newDesktopElements, (candidate) => {
    const containingCandidate = _.find(allContainingElements, ['id', candidate.id]);
    // let isTextThatCanOverlap = false;
    // if (isTextElement(candidate.type)) {
    //   isTextThatCanOverlap = checkIfTextThatCanOverlap(currDesktopElement, candidate) && _.isEmpty(_.filter(overlappingElements, (element) => isTextElement(element.type)));
    // }
    // if ((currDesktopElement.id !== candidate.id && !containingCandidate && !isFullWidth(desktopIdsNewMobileElements[candidate.id].type) && !isTextElement(candidate.type) && !isTextElement(currDesktopElement.type)) || isTextThatCanOverlap) {
    if (currDesktopElement.id !== candidate.id && !containingCandidate && !isFullWidth(desktopIdsNewMobileElements[candidate.id].type) && !isTextElement(candidate.type)) {
      if (checkIfElementsOverlap(currElementRect, getElementRect(candidate))) {
        directlyOverlappingElements.push(candidate);
        overlappingElements.push(candidate);
      } else {
        nonOverlappingElements.push(candidate);
      }
    }
  });
  _.forEach(directlyOverlappingElements, (element) => {
    const containingElement = _.find(allContainingElements, ['id', element.id]);
    // if (!containingElement && !isFullWidth(element.type)) {
    if (!containingElement && !isFullWidth(element.type) && !isTextElement(element.type)) {
      overlappingElements = _.union(overlappingElements, findOverlappingElements(nonOverlappingElements, desktopIdsNewMobileElements, element, allContainingElements));
    }
  });
  if (_.isEmpty(overlappingElements)) {
    return null;
  }
  return overlappingElements;
}

function getOverlappingElementsLayouts(overlappingElements, currYPosition, containerLayout) {
  const resizedElementsLayouts = {};
  const combinedLayout = getCombinedLayout(overlappingElements);
  const resizedCombinedLayout = getUpdatedMobileLayout(combinedLayout, currYPosition, containerLayout);
  const ratio = resizedCombinedLayout.height / combinedLayout.height;
  _.forEach(overlappingElements, (element) => {
    resizedElementsLayouts[element.id] = {
      width: Math.ceil(element.layout.width * ratio),
      height: Math.ceil(element.layout.height * ratio),
      x: Math.ceil(((element.layout.x - combinedLayout.x) * ratio) + resizedCombinedLayout.x),
      y: Math.ceil(((element.layout.y - combinedLayout.y) * ratio) + resizedCombinedLayout.y),
    };
  });
  return { resizedElementsLayouts: resizedElementsLayouts, combinedLayout: resizedCombinedLayout, ratio: ratio };
}

function getMobileLElementLayout(element, currYPosition, containerLayout) {
  const mobileElementLayout = getUpdatedMobileLayout(element.layout, currYPosition, containerLayout, isFullWidth(element.type));
  // TODO need to see why this is needed
  if (shouldPreserveAspectRatio(element.type)) {
    return _.merge({}, mobileElementLayout, {aspectRatio: mobileElementLayout.width / mobileElementLayout.height});
  }
  return mobileElementLayout;
}

function updateOverlappingElements(overlappingElements, updatedVisibleMobileElements, currYPosition, containerLayout) {
  const resizedOverlappingElementsLayouts = getOverlappingElementsLayouts(overlappingElements, currYPosition, containerLayout);
  _.forEach(overlappingElements, (element) => {
    const resizedElementLayout = resizedOverlappingElementsLayouts.resizedElementsLayouts[element.id];
    if (isTextElement(element.type)) {
      const { value, unit } = getElementFontSize(element);
      let resizedFontSize = Math.max(Math.ceil(value * resizedOverlappingElementsLayouts.ratio), MINIMUM_MOBILE_FONT_SIZE);
      if (unit) {
        resizedFontSize += unit;
      }
      updatedVisibleMobileElements[element.id] = _.merge({}, element, {layout: resizedElementLayout, data: {compProps: {fontSize: resizedFontSize}}});
    } else {
      updatedVisibleMobileElements[element.id] = _.merge({}, element, {layout: resizedElementLayout});
    }
  });
  return resizedOverlappingElementsLayouts.combinedLayout.height + SPACE_BETWEEN_MOBILE_ELEMENTS;
}

function updateNewMobileElement(currNewElement, updatedVisibleMobileElements, currYPosition, containerLayout) {
  const resizedNewMobileElement = _.merge({}, currNewElement, {layout: getMobileLElementLayout(currNewElement, currYPosition, containerLayout)});
  updatedVisibleMobileElements[resizedNewMobileElement.id] = resizedNewMobileElement;
  return resizedNewMobileElement.layout.height + SPACE_BETWEEN_MOBILE_ELEMENTS;
}

function addNewMobileElementToUpdatedVisibleMobileElements(desktopIdsNewMobileElements, newDesktopElements, currElement, updatedVisibleMobileElements, currYPosition, containerLayout, allContainingElements) {
  const mobileCurrElement = desktopIdsNewMobileElements[currElement.id];
  const containingElement = _.find(allContainingElements, ['id', currElement.id]);
  // const overlappingElements = containingElement || isFullWidth(mobileCurrElement.type) ? null : findOverlappingElements(newDesktopElements, desktopIdsNewMobileElements, currElement, allContainingElements);
  const overlappingElements = containingElement || isFullWidth(mobileCurrElement.type) || isTextElement(mobileCurrElement.type) ? null : findOverlappingElements(newDesktopElements, desktopIdsNewMobileElements, currElement, allContainingElements);
  const overlappingMobileElements = [];
  _.forEach(overlappingElements, (overlappingElement) => {
    overlappingMobileElements.push(desktopIdsNewMobileElements[overlappingElement.id]);
  });
  if (!_.isEmpty(overlappingMobileElements)) {
    overlappingMobileElements.push(mobileCurrElement);
    return updateOverlappingElements(overlappingMobileElements, updatedVisibleMobileElements, currYPosition, containerLayout);
  }
  return updateNewMobileElement(mobileCurrElement, updatedVisibleMobileElements, currYPosition, containerLayout);
}

function filterOutContainedMobileElements(desktopIdsNewMobileElements, containingElement) {
  let newMobileElementsWithoutContainedElements = {};
  if (containingElement) {
    _.forEach(desktopIdsNewMobileElements, (newMobileElement) => {
      if (!containingElement.containedElements.allContainedElements[newMobileElement.desktopId]) {
        newMobileElementsWithoutContainedElements[newMobileElement.desktopId] = newMobileElement;
      }
    });
  } else {
    newMobileElementsWithoutContainedElements = desktopIdsNewMobileElements;
  }
  return newMobileElementsWithoutContainedElements;
}

function arrangeMobileElements(desktopIdsNewMobileElements, sortedOldMobileElements, sortedDesktopElements, containingElementsTree, elementsToIgnore, startingYPosition, sumAlreadyTreatedNewElementsSizes, containerLayout) {
  // this function is inside another function to enable mutual recursion
  function addContainedElementsToUpdatedVisibleMobileElements(desktopIdsNewMobileElements, sortedOldMobileElements, currElement, containingElement, updatedVisibleMobileElements, currYPosition, sumAlreadyTreatedNewElementsSizes) {
    if (!_.isEmpty(_.filter(containingElement.containedElements.allContainedElements, (containedElement) => desktopIdsNewMobileElements[containedElement.id]))) {
      const containedElements = containingElement.containedElements;
      const containedNewMobileElements = {};
      let arrangedContainedElements;
      _.forEach(desktopIdsNewMobileElements, (newElement) => {
        if (containedElements.allContainedElements[newElement.desktopId]) {
          containedNewMobileElements[newElement.desktopId] = newElement;
        }
      });
      const containedSortedOldMobileElements = [];
      _.forEach(sortedOldMobileElements, (oldElement) => {
        if (containedElements.allContainedElements[oldElement.desktopId]) {
          containedSortedOldMobileElements.push(oldElement);
        }
      });
      const containingElementsInsideContainedElements = {};
      _.forEach(containedElements.structuredContainedElements, (containedElement) => {
        if (!_.isEmpty(containedElement.containedElements.allContainedElements)) {
          containingElementsInsideContainedElements[containedElement.id] = containedElement;
        }
      });
      arrangedContainedElements = arrangeMobileElements(containedNewMobileElements, containedSortedOldMobileElements, _.sortBy(containedElements.allContainedElements, ['layout.y', 'layout.x']), containingElementsInsideContainedElements, updatedVisibleMobileElements, currYPosition + CONTAINING_MOBILE_ELEMENT_BOUNDRIES, sumAlreadyTreatedNewElementsSizes, updatedVisibleMobileElements[currElement.id].layout);
      updatedVisibleMobileElements = arrangedContainedElements.updatedVisibleMobileElements;
      const addedElementHeight = arrangedContainedElements.containerHeight + (2 * CONTAINING_MOBILE_ELEMENT_BOUNDRIES);
      updatedVisibleMobileElements[currElement.id] = _.merge({}, updatedVisibleMobileElements[currElement.id], {layout: {height: addedElementHeight}});
      return addedElementHeight + SPACE_BETWEEN_MOBILE_ELEMENTS;
    }
    return -1;
  }

  let currYPosition = startingYPosition;
  let sumNewElementsSizes = sumAlreadyTreatedNewElementsSizes;
  let currDesktopElement;
  let currDesktopElementIndex;
  let currNewElement;
  const updatedVisibleMobileElements = elementsToIgnore;
  const allContainingElements = getAllContainingElements(containingElementsTree);

  // add new elements that are above all the old elements
  _.forEach(sortedDesktopElements, (element) => {
    currNewElement = desktopIdsNewMobileElements[element.id];
    if (!currNewElement) {
      return false;
    }
    if (!updatedVisibleMobileElements[currNewElement.id]) {
      const containingElement = containingElementsTree ? containingElementsTree[element.id] : null;
      const filteredOutContainedMobileElements = filterOutContainedMobileElements(desktopIdsNewMobileElements, containingElement);
      const newDesktopElements = _.filter(sortedDesktopElements, (desktopElement) => filteredOutContainedMobileElements[desktopElement.id]);
      let addedElementHeight = addNewMobileElementToUpdatedVisibleMobileElements(filteredOutContainedMobileElements, newDesktopElements, element, updatedVisibleMobileElements, currYPosition, containerLayout, allContainingElements);
      if (containingElement) {
        const updatedAddedElementHeight = addContainedElementsToUpdatedVisibleMobileElements(desktopIdsNewMobileElements, sortedOldMobileElements, currNewElement, containingElement, updatedVisibleMobileElements, currYPosition, sumNewElementsSizes);
        if (updatedAddedElementHeight !== -1) {
          addedElementHeight = updatedAddedElementHeight;
        }
      }
      sumNewElementsSizes += addedElementHeight;
      currYPosition += addedElementHeight;
    }
  });

  _.forEach(sortedOldMobileElements, (oldElement) => {
    if (!updatedVisibleMobileElements[oldElement.id]) {
      currDesktopElementIndex = _.findIndex(sortedDesktopElements, ['id', oldElement.desktopId]);
      let containingElement = containingElementsTree ? containingElementsTree[oldElement.desktopId] : null;
      const oldElementNewYPosition = oldElement.layout.y + sumNewElementsSizes;
      updatedVisibleMobileElements[oldElement.id] = _.merge({}, oldElement, {layout: {y: oldElementNewYPosition}});
      if (containingElement) {
        addContainedElementsToUpdatedVisibleMobileElements(desktopIdsNewMobileElements, sortedOldMobileElements, oldElement, containingElement, updatedVisibleMobileElements, currYPosition, sumNewElementsSizes);
      }
      sumNewElementsSizes += updatedVisibleMobileElements[oldElement.id].layout.height - oldElement.layout.height;
      currYPosition = oldElementNewYPosition + updatedVisibleMobileElements[oldElement.id].layout.height + SPACE_BETWEEN_MOBILE_ELEMENTS;
      currDesktopElement = sortedDesktopElements[++currDesktopElementIndex];
      while (currDesktopElement && desktopIdsNewMobileElements[currDesktopElement.id]) {
        currNewElement = desktopIdsNewMobileElements[currDesktopElement.id];
        if (!updatedVisibleMobileElements[currNewElement.id]) {
          containingElement = containingElementsTree ? containingElementsTree[currNewElement.desktopId] : null;
          const filteredOutContainedMobileElements = filterOutContainedMobileElements(desktopIdsNewMobileElements, containingElement);
          const newDesktopElements = _.filter(sortedDesktopElements, (desktopElement) => filteredOutContainedMobileElements[desktopElement.id]);
          let addedElementHeight = addNewMobileElementToUpdatedVisibleMobileElements(filteredOutContainedMobileElements, newDesktopElements, currDesktopElement, updatedVisibleMobileElements, currYPosition, containerLayout, allContainingElements);
          if (containingElement) {
            const updatedAddedElementHeight = addContainedElementsToUpdatedVisibleMobileElements(desktopIdsNewMobileElements, sortedOldMobileElements, currNewElement, containingElement, updatedVisibleMobileElements, currYPosition, sumNewElementsSizes);
            if (updatedAddedElementHeight !== -1) {
              addedElementHeight = updatedAddedElementHeight;
            }
          }
          sumNewElementsSizes += addedElementHeight;
          currYPosition += addedElementHeight;
        }
        currDesktopElement = sortedDesktopElements[++currDesktopElementIndex];
      }
    }
  });

  return {updatedVisibleMobileElements: updatedVisibleMobileElements, containerHeight: currYPosition - startingYPosition - SPACE_BETWEEN_MOBILE_ELEMENTS};
}

function getContainedOldElementsToBeReevaluated(containingElementsTree, desktopIdsNewMobileElements, oldMobileElements) {
  const containedOldELementsToBeReevaluated = {};
  _.forEach(containingElementsTree, (containingElement) => {
    if (!_.isEmpty(_.filter(containingElement.containedElements.structuredContainedElements, (containedElement) => desktopIdsNewMobileElements[containedElement.id]))) {
      _.forEach(containingElement.containedElements.structuredContainedElements, (containedElement) => {
        const oldMobileContainedElement = _.find(oldMobileElements, ['desktopId', containedElement.id]);
        if (oldMobileContainedElement) {
          containedOldELementsToBeReevaluated[containedElement.id] = _.merge({}, oldMobileContainedElement, {layout: {x: containedElement.layout.x, y: containedElement.layout.y}});
        }
      });
    }
  });
  return containedOldELementsToBeReevaluated;
}

export default function reducer(state = {}, action = {}) {
  let elementLayout;
  let element;
  let elementId;
  let pageElement;
  let elementsToUpdate = {};
  let elementList;

  switch (action.type) {
    case elementActionTypes.HIDE_MOBILE_ELEMENT:
      const updatedMobileElements = getUpdatedMobileElementsAfterDelete(state, action.ids, getPageElement(state.mobile.staticElements));
      elementsToUpdate = {};
      _.forEach(updatedMobileElements.elements, (updatedMobileElement) => {
        if (_.includes(action.ids, updatedMobileElement.id)) {
          elementsToUpdate[updatedMobileElement.id] = {
            hidden: {
              $set: true
            }
          };
        } else {
          elementsToUpdate[updatedMobileElement.id] = {
            layout: {
              height: {
                $set: updatedMobileElement.layout.height
              },
              y: {
                $set: updatedMobileElement.layout.y
              }
            }
          };
        }
      });
      if (!_.isEmpty(elementsToUpdate)) {
        return update(state, {
          mobile: {
            elements: elementsToUpdate,
            staticElements: updatedMobileElements.staticElements
          }
        });
      }
      return state;
    case elementActionTypes.SHOW_MOBILE_ELEMENT:
      element = state.mobile.elements[action.id];
      pageElement = getPageElement(state.mobile.staticElements);
      const elementPosY = Math.max(Math.ceil(getYPositionAtMiddleOfView() - (element.layout.height / 2)), 0);
      const pageHeight = Math.max(elementPosY + element.layout.height, pageElement.layout.height);

      return update(state, {
        mobile: {
          elements: {
            [action.id]: {
              hidden: {
                $set: false
              },
              compProps: {
                zIndex: {
                  $set: getMaxZIndex(state.mobile.elements) + 1
                }
              },
              layout: {
                y: {
                  $set: elementPosY
                }
              }
            }
          },
          staticElements: {
            [PAGE_ELEMENT_ID]: {
              layout: {
                height: {
                  $set: pageHeight
                }
              }
            }
          }
        }
      });
    case elementActionTypes.ADD_MOBILE_ELEMENTS_FIRST_STEP:
      // first step is saving the elements in the store at newMobileElements
      const elementsToAdd = {};
      _.forEach(action.elements, (element) => {
        const isElementFullWidth = isFullWidth(element.type);
        let updatedMobileLayout = element.layout;
        if (isTextElement(element.type) || isElementFullWidth) {
          updatedMobileLayout = getUpdatedMobileLayout(element.layout, 0, getPageElement(state.mobile.staticElements).layout, isElementFullWidth);
        }
        elementsToAdd[element.id] = _.merge({}, element, {layout: {height: updatedMobileLayout.height, width: updatedMobileLayout.width}});
      });
      return update(state, {
        newMobileElements: {
          $set: elementsToAdd
        },
        addMobileElementsStep: {
          $set: ADD_MOBILE_ELEMENTS_SECOND_STEP
        }
      });
    case elementActionTypes.ADD_MOBILE_ELEMENTS_SECOND_STEP:
      // some elements change their height according to their width (title element for example)
      // so we need to render them in mobile view to get their real heights
      // second step is resizing the new elements layout to match their real height
      // step must happen after the new mobile elements have been rendered to mobile view
      elementsToUpdate = resizeMobileElements(state.newMobileElements);
      if (!_.isEmpty(elementsToUpdate)) {
        return update(state, {
          newMobileElements: elementsToUpdate.elements,
          addMobileElementsStep: {
            $set: ADD_MOBILE_ELEMENTS_THIRD_STEP
          }
        });
      }
      return update(state, {
        addMobileElementsStep: {
          $set: ADD_MOBILE_ELEMENTS_THIRD_STEP
        }
      });
    case elementActionTypes.ADD_MOBILE_ELEMENTS_THIRD_STEP:
      // third step is adding the new mobile elements to the rest of the elements in the proper place, updating their y coordinate
      if (_.isEmpty(state.newMobileElements)) {
        console.warn('Third step of adding mobile elements - No new elements to add...');
        return state;
      }

      const hiddenOldMobileElements = getHiddenElements(state.mobile.elements);
      let sortedDesktopElements = _.sortBy(_.filter(state.desktop.elements, (desktopElement) => !_.find(hiddenOldMobileElements, ['desktopId', desktopElement.id])), ['layout.y', 'layout.x']);
      const containingElementsTree = getContainingElementsTree(sortedDesktopElements);
      const allContainedElements = getAllContainedElements(containingElementsTree);
      sortedDesktopElements = _.filter(sortedDesktopElements, (desktopElement) => !allContainedElements[desktopElement.id]);
      const desktopIdsNewMobileElements = {};
      _.forEach(state.newMobileElements, (newElement) => {
        desktopIdsNewMobileElements[newElement.desktopId] = newElement;
      });
      const visibleOldMobileElements = getVisibleElements(state.mobile.elements);
      const containedOldElementsToBeReevaluated = getContainedOldElementsToBeReevaluated(containingElementsTree, desktopIdsNewMobileElements, visibleOldMobileElements);
      const sortedOldMobileElements = _.sortBy(_.filter(visibleOldMobileElements, (element) => {
        return !(element.parentId || containedOldElementsToBeReevaluated[element.desktopId]);
      }), ['layout.y', 'layout.x']);

      const {updatedVisibleMobileElements, containerHeight} = arrangeMobileElements(_.merge({}, desktopIdsNewMobileElements, containedOldElementsToBeReevaluated), sortedOldMobileElements, sortedDesktopElements, containingElementsTree, getChildElements(_.merge({}, state.newMobileElements, visibleOldMobileElements)), 0, 0, getPageElement(state.mobile.staticElements).layout);
      const finalMobileElements = _.merge({}, updatedVisibleMobileElements, hiddenOldMobileElements);
      if (containerHeight > state.mobile.staticElements[PAGE_ELEMENT_ID].layout.height) {
        return update(state, {
          newMobileElements: {
            $set: null
          },
          mobile: {
            elements: {
              $set: finalMobileElements
            },
            staticElements: {
              page: {
                layout: {
                  height: {
                    $set: containerHeight
                  }
                }
              }
            }
          },
          addMobileElementsStep: {
            $set: ADD_MOBILE_ELEMENTS_FIRST_STEP
          }
        });
      }
      return update(state, {
        newMobileElements: {
          $set: null
        },
        mobile: {
          elements: {
            $set: finalMobileElements
          }
        },
        addMobileElementsStep: {
          $set: ADD_MOBILE_ELEMENTS_FIRST_STEP
        }
      });
    case elementActionTypes.UPDATE_MOBILE_ELEMENT:
      elementId = _.isArray(action.ids) ? action.ids[0] : action.ids;
      elementList = getElementList(elementId);
      element = state.mobile[elementList][elementId];

      return update(state, {
        mobile: {
          [elementList]: {
            [elementId]: {
              $set: _.merge({}, element, action.elementProps)
            }
          }
        },
        preview: {
          $set: null
        }
      });
    case elementActionTypes.RESIZE_MOBILE_ELEMENTS:
      elementsToUpdate = resizeMobileElements(getVisibleElements(state.mobile.elements), getPageElement(state.mobile.staticElements));
      if (!_.isEmpty(elementsToUpdate)) {
        return update(state, {
          mobile: elementsToUpdate
        });
      }
      return state;
    default:
      return state;
  }
}
